import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum ConfirmDialogState {
    Confirmed, Cancalled, Unknown
}

export class State {
    id: string;
    message: string;
    showIcon: boolean;
    okText?: string;
    cancelText?: string;
    state: ConfirmDialogState;
}

@Injectable()
export class ConfirmDialogService {

    private _confirmDialogSource = new BehaviorSubject<any>({});
    confirmDialogSource$ = this._confirmDialogSource.asObservable();

    setState(state: State) {
        this._confirmDialogSource.next(state);
    }
}
